import {parseAppZoneDate} from '@/utils/dateUtils'

/**
 * Wall-clock time of a server timestamp, in the reader's own zone.
 *
 * ⚠️ THE INSTANT IS RESOLVED IN THE APP ZONE FIRST. The backend sends Toronto wall clock
 * with no offset on it, and a bare `new Date` reads that as the VIEWER's local time — so a
 * delay reported at 3:41 PM in Pearson shows as 12:41 PM to a reader in Vancouver and
 * 8:41 PM to one in London. The mobile app has exactly this bug in its delay bubbles.
 *
 * Once the instant is right, it is DISPLAYED wherever the reader is, which for a passenger
 * who has just flown in is the right frame — they are reading a clock in the terminal.
 */
export function formatDelayTime(value) {
    const date = parseAppZoneDate(value)
    if (!date || Number.isNaN(date.getTime())) return ''
    return date.toLocaleTimeString([], {hour: 'numeric', minute: '2-digit'})
}

export default formatDelayTime
